module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "form-map",
      "data-vv-scope": "settings_form"
    }
  }, [(Object.keys(_vm.filteredColumnsMap).length && _vm.isForm) ? _c('h3', [_c('i', {
    staticClass: "fa",
    class: _vm.columnsMapLocked ? 'fa-lock' : 'fa-unlock-alt',
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setColumnsMapLock(!_vm.columnsMapLocked)
      }
    }
  }), _vm._v("\n    Map Data\n    "), (_vm.allowAddingCustomFields && (_vm.columnsMapLocked === false || _vm.customColumnsMap === null)) ? _c('span', {
    staticClass: "pull-right options-gear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.customFieldModalShow()
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings right"
  })]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredColumnsMap), function(item) {
    return (_vm.isForm) ? _c('div', {
      staticClass: "form-group",
      class: {
        'has-error': _vm.errors.has('settings_form.columnsMap_' + item.name)
      }
    }, [_c('label', [(_vm.isRequired(item)) ? _c('span', [_vm._v(" *")]) : _vm._e(), _vm._v(_vm._s(item.label) + "\n    ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.isRequired(item) ? 'required' : ''),
        expression: "isRequired(item) ? 'required' : ''"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.valueMap[item.name]),
        expression: "valueMap[item.name]"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'columnsMap_' + item.name,
        "data-vv-as": item.label,
        "disabled": _vm.columnsMapLocked
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.valueMap, item.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.$emit('update', Object.assign({}, {value: $event.target.value},
            item))
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": _vm.isRequired(item),
        "hidden": _vm.isRequired(item)
      },
      domProps: {
        "value": null,
        "selected": _vm.isRequired(item)
      }
    }), _vm._v(" "), _vm._l((_vm.fieldOptions), function(field) {
      return _c('option', {
        domProps: {
          "value": field.name
        }
      }, [_vm._v("\n        " + _vm._s(field.description) + "\n      ")])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('settings_form.columnsMap_' + item.name)),
        expression: "errors.has('settings_form.columnsMap_'+item.name)"
      }],
      staticClass: "help-block"
    }, [_vm._v(_vm._s(_vm.errors.first('settings_form.columnsMap_' + item.name)))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.customColumnsMap), function(item, key) {
    return (_vm.isForm) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', [_c('label', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "icon-settings",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editCustomFieldModalShow(key)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.destroyCustomColumn(key)
        }
      }
    })])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'columnsMap_' + item.name,
        "data-vv-as": item.label,
        "disabled": _vm.columnsMapLocked
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((_vm.fieldOptions), function(field) {
      return _c('option', {
        domProps: {
          "value": field.name
        }
      }, [_vm._v("\n        " + _vm._s(field.description) + "\n      ")])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('settings_form.columnsMap_' + item.name)),
        expression: "errors.has('settings_form.columnsMap_'+item.name)"
      }],
      staticClass: "help-block"
    }, [_vm._v(_vm._s(_vm.errors.first('settings_form.columnsMap_' + item.name)))])]) : _vm._e()
  }), _vm._v(" "), _c('form-builder-new-custom-field', {
    attrs: {
      "id": "custom-field-modal"
    },
    on: {
      "new-custom-field": _vm.newCustomField
    }
  }), _vm._v(" "), _c('form-builder-edit-custom-field', {
    attrs: {
      "id": "edit-custom-field-modal",
      "index": _vm.editingCustomColumnIndex,
      "original-field-name": _vm.editingCustomColumnFieldName
    },
    on: {
      "update-custom-field": _vm.editCustomField
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411f9472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueMapData.vue
// module id = 1616
// module chunks = 1